import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "zig-icon"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.6202 6.6083L9.4001 14.8284L6.37973 11.8081C6.23329 11.6616 5.99585 11.6616 5.84939 11.8081L4.96551 12.6919C4.81907 12.8384 4.81907 13.0758 4.96551 13.2223L9.13492 17.3917C9.28135 17.5381 9.51879 17.5381 9.66526 17.3917L19.0344 8.02252C19.1809 7.87608 19.1809 7.63865 19.0344 7.49218L18.1505 6.6083C18.0041 6.46186 17.7667 6.46186 17.6202 6.6083Z",
    fill: props.color
  }));
};

export { SvgCheckIcon as ReactComponent };
